export function fechaVisible(fecha) {
  if (fecha === null) return null;
  return new Intl.DateTimeFormat("es-MX").format(new Date(fecha));
}

export function fechaHoraVisible(fecha) {
  if (fecha === null) return null;
  return new Intl.DateTimeFormat("es-MX", {
    dateStyle: "short",
    timeStyle: "short",
  }).format(new Date(fecha));
}

export function hoy() {
  const fecha = new Date();
  const mes = String(fecha.getMonth() + 1).padStart(2, "0");
  const dia = String(fecha.getDate()).padStart(2, "0");
  return `${fecha.getFullYear()}-${mes}-${dia}`;
}
